import { SitecoreMediaItem } from 'common/types/sitecore';

export function getSharedMediaItem<T extends Record<string, SitecoreMediaItem>>(
  fields: T,
  fieldName: keyof T
): SitecoreMediaItem | undefined {
  const localizedMediaItem = fields?.[fieldName];
  const isLocalizedMediaItemSpecified: boolean = !!localizedMediaItem?.url;
  if (isLocalizedMediaItemSpecified) {
    return localizedMediaItem;
  }

  const sharedString = `${String(fieldName)}Shared` as keyof T;
  const sharedMediaItem = fields?.[sharedString];
  const isSharedMediaItemSpecified: boolean = !!sharedMediaItem?.url;
  return isSharedMediaItemSpecified ? sharedMediaItem : undefined;
}

const isMediaItemValue = (value: unknown): value is SitecoreMediaItem => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'url' in value &&
    typeof value.url === 'string' &&
    'name' in value &&
    typeof value.name === 'string' &&
    'fields' in value &&
    typeof value.fields === 'object' &&
    value.fields !== null &&
    'Alt' in value.fields &&
    'Title' in value.fields
  );
};

export const isMediaItem = (field: unknown): field is SitecoreMediaItem => {
  return typeof field === 'object' && field !== null && isMediaItemValue(field);
};
